import { render } from "./UploadExcel.vue?vue&type=template&id=19f4d1ce&scoped=true"
import script from "./UploadExcel.vue?vue&type=script&lang=js"
export * from "./UploadExcel.vue?vue&type=script&lang=js"

import "./UploadExcel.vue?vue&type=style&index=0&id=19f4d1ce&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f4d1ce"]])

export default __exports__